
import { CommandType } from "../../../../common/services/cqs/CommandType";
import { Kontrakt } from "../../models/kontrakt-models";
import { KontraktCommandBase } from "./KontraktCommandBase";

export class CreateKontraktCommand extends KontraktCommandBase {
// eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "CreateKontraktCommand";

    constructor(kontrakt: Kontrakt, avtalGuid: string) {
        super(avtalGuid, kontrakt.guid, CreateKontraktCommand.$type, CommandType.Insert);
    }
}
